export const help = 'https://accelaero.com';
export const termsOfUse = 'https://accelaero.com';
export const privacyPolicy = 'https://accelaero.com';
